import React from "react";
import { Truck } from "lucide-react";
import { cn } from "../lib/utils";
import { fmtDateTime } from "../lib/auditFormat";

/** Inline badge pill — for use in tables/cards. */
export function TransitHoldBadge({ className, testid = "transit-hold-badge" }) {
  return (
    <span
      data-testid={testid}
      className={cn(
        "inline-flex items-center gap-1 rounded-md border border-blue-200 bg-blue-50 px-1.5 py-0.5 text-[10px] font-bold uppercase tracking-wider text-blue-800",
        className,
      )}
    >
      <Truck className="h-3 w-3" />
      Transit Hold
    </span>
  );
}

/** Full-width banner used inside detail/workspace pages. */
export function TransitHoldBanner({ sale, action, className }) {
  if (!sale?.transit_hold?.active) return null;
  const engagedAt = sale.transit_hold.engaged_at
    ? fmtDateTime(sale.transit_hold.engaged_at)
    : null;
  return (
    <div
      data-testid="transit-hold-banner"
      className={cn(
        "flex flex-col gap-2 rounded-lg border border-blue-200 bg-blue-50 p-4 sm:flex-row sm:items-center sm:justify-between",
        className,
      )}
    >
      <div className="flex items-start gap-3">
        <Truck className="mt-0.5 h-5 w-5 flex-shrink-0 text-blue-700" />
        <div>
          <div className="text-sm font-semibold text-blue-900">
            Vehicle marked as In Transit. Back-office processes are paused until release.
          </div>
          {engagedAt && (
            <div className="mt-0.5 text-xs text-blue-700">
              On hold since {engagedAt}. SLA timers paused.
            </div>
          )}
        </div>
      </div>
      {action}
    </div>
  );
}
